import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { CommunityBoard } from "@/components/CommunityBoard";
import { EventsSection } from "@/components/EventsSection";
import { HousingSection } from "@/components/HousingSection";
import { JobsSection } from "@/components/JobsSection";
import { BusinessSection } from "@/components/BusinessSection";
import { Newsletter } from "@/components/Newsletter";
import { FeedbackSection } from "@/components/FeedbackSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <CommunityBoard />
      <EventsSection />
      <HousingSection />
      <JobsSection />
      <BusinessSection />
      <Newsletter />
      <FeedbackSection />
      <Footer />
    </div>
  );
}
